import actions from './Actions'
import categories from './Categories'
import EventsUtil from './EventsUtil'
import labels from './Labels'

export {
  EventsUtil,
  categories,
  actions,
  labels
}

window.zooz_analytics = {
  EventsUtil,
  categories,
  actions,
  labels
}
